import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslatePipe } from '@ngx-translate/core';

export type LoadingSpinnerSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const LOADING_SPINNER_SIZES: Record<LoadingSpinnerSize, number> = {
    xs: 18,
    sm: 24,
    md: 32,
    lg: 40,
    xl: 100,
};

/** Accessible loading indicator wrapping Material's progress spinner with a translated default label and size presets. */
@Component({
    selector: 'apcam-loading-spinner',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatProgressSpinner, TranslatePipe],
    templateUrl: './loading-spinner.component.html',
    styleUrl: './loading-spinner.component.scss',
})
export class LoadingSpinnerComponent {
    readonly ariaLabel = input('shared.loading.spinnerLabel');
    readonly ariaLabelParams = input<Record<string, unknown> | undefined>(
        undefined
    );
    readonly centered = input(false, { transform: booleanAttribute });
    readonly color = input<ThemePalette>('primary');
    readonly size = input<LoadingSpinnerSize>('xl');

    protected readonly diameter = computed(
        () => LOADING_SPINNER_SIZES[this.size()]
    );
}
